import { Group, Spinner, Text } from '@optiaxiom/react';
import styles from './AppsPage.module.css';

/** Shown while the apps list request (GET /dev-portal/apps) is in flight. */
export function AppsLoading() {
  return (
    <Group alignItems="center" flexDirection="column" className={styles.stateContainer}>
      <Spinner />
      <Text color="fg.secondary">Loading your apps…</Text>
    </Group>
  );
}
